export default "__VITE_ASSET__KlietTIm__"